// ⚠️  MOBILE-FIRST. "Getting started" checklist shown to brand-new users
// (fewer than 3 workouts). Disappears once all steps are done or dismissed.
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircle2, Circle, ChevronRight, X } from "lucide-react";

const DISMISS_KEY = "nerdy_gsc_dismissed";
const SEEN_LB_KEY = "nerdy_seen_leaderboard";

export default function GettingStartedCard({ totalWorkouts, squatsId }) {
    const navigate = useNavigate();
    const [dismissed, setDismissed] = useState(() => localStorage.getItem(DISMISS_KEY) === "1");

    const remindersOn = typeof Notification !== "undefined" && Notification.permission === "granted";
    const seenLeaderboard = localStorage.getItem(SEEN_LB_KEY) === "1";

    const items = [
        {
            id: "first-workout",
            label: "Do your first workout",
            hint: "~90 seconds, camera counts the reps",
            done: totalWorkouts > 0,
            go: () => navigate(squatsId ? `/workout/${squatsId}` : "/exercises"),
        },
        {
            id: "reminders",
            label: "Turn on streak reminders",
            hint: "so you never lose a streak by accident",
            done: remindersOn,
            go: () => navigate("/profile"),
        },
        {
            id: "leaderboard",
            label: "Check the leaderboard",
            hint: "see where you rank",
            done: seenLeaderboard,
            go: () => navigate("/leaderboard"),
        },
    ];

    const allDone = items.every((i) => i.done);
    if (dismissed || allDone || totalWorkouts >= 3) return null;

    const dismiss = () => {
        localStorage.setItem(DISMISS_KEY, "1");
        setDismissed(true);
    };

    return (
        <div className="gsc" data-testid="getting-started-card">
            <div className="gsc-head">
                <span className="lab">Getting started</span>
                <button className="gsc-x" onClick={dismiss} aria-label="Dismiss" data-testid="getting-started-dismiss">
                    <X size={15} />
                </button>
            </div>
            {items.map((item) => (
                <button
                    key={item.id}
                    type="button"
                    className={`gsc-row ${item.done ? "done" : ""}`}
                    onClick={item.go}
                    data-testid={`gsc-${item.id}`}
                >
                    {item.done
                        ? <CheckCircle2 size={20} className="ic ok" />
                        : <Circle size={20} className="ic" />}
                    <span className="mid">
                        <span className="l">{item.label}</span>
                        <span className="h">{item.hint}</span>
                    </span>
                    {!item.done && <ChevronRight size={16} className="chev" />}
                </button>
            ))}
        </div>
    );
}
